import React from 'react';
import sugar from "../../assets/productimage/sugar.png";
import Agro from "../../assets/productimage/argofeed.png";
import dryfish from "../../assets/productimage/dryfish.png";
import foodgrains from "../../assets/productimage/wheat.png";
import meat from "../../assets/productimage/meat.png";
import oil from "../../assets/productimage/oil.png";
import pulese from "../../assets/productimage/pulse.png";
import salt from "../../assets/productimage/salt.png";
import seed from "../../assets/productimage/agriculseed.png";
import spices from "../../assets/productimage/spices.png";
import vegitables from "../../assets/productimage/veg .png";
import seafood from "../../assets/productimage/seafood.png";


import "./ourproduct.css";

function Ourproduct() {
    const products = [
        { name: "Sugar", description: "We offer high-quality sugar with the best benefits, ensuring purity, rich taste, and energy boost. Perfect for daily use in food, beverages, and industrial needs.", image: sugar, button:"/products/sugar"},
        { name: "Spices", description: "We offer premium quality spices that enhance flavor, aroma, and health benefits. Perfect for cooking, medicinal use, and adding rich taste to every dish!", image: spices, button:"/products/spices" },
        { name: "Food Grains", description: "We provide top-quality food grains that are fresh, nutritious, and perfect for everyday meals. Whether it's rice, wheat, or pulses, we ensure purity and great taste in every grain!", image: foodgrains, button:"/products/food-grains" },
        { name: "Salt", description: "We offer pure and high-quality salt, perfect for enhancing flavor and maintaining health. Whether for cooking or industrial use, our salt is rich in minerals and freshness!", image: salt, button:"/products/salt" },
        { name: "Agro Feed", description: "We provide high-quality agro feed, formulated for optimal nutrition, better growth, and higher productivity in livestock and poultry.", image: Agro, button:"/products/agro-feed" },
        { name: "Vegetable", description: "We offer fresh, farm-grown vegetables packed with natural nutrients, rich flavor, and premium quality. Straight from the fields to your table for a healthier life!", image: vegitables, button:"/products/vegitables"},
        { name: "Oil", description: "We provide pure, high-quality oil that enhances flavor while ensuring health and nutrition. Perfect for cooking, frying, and a balanced lifestyle!", image: oil, button:"/products/oil" },
        { name: "Agriculture Seeds", description: "We offer high-quality agriculture seeds with superior germination, high yield, and disease resistance. Grow healthier crops and ensure a prosperous harvest!", image: seed, button:"/products/agriculture-seeds"},
        { name: "Meat", description: "We provide premium-quality buffalo and goat meat, ensuring freshness, rich flavor, and high nutritional value. Perfect for wholesome, protein-rich meals!", image: meat, button:"/products/meat" },
        { name: "Sea Foods", description: "We offer fresh and high-quality seafood, packed with essential nutrients, omega-3 fatty acids, and rich flavor. Perfectly cleaned, hygienically packed, and delivered fresh for ultimate taste and health!", image: seafood, button:"/products/sea-foods" },
        { name: "Dry Fish", description: "We provide premium-quality dry fish, rich in protein, omega-3, and essential nutrients for a healthy diet. Carefully dried and hygienically packed to retain freshness and taste!", image: dryfish, button:"/products/dry-fish" },
        { name: "Pulses", description: "We offer premium, farm-fresh pulses packed with high protein, essential nutrients, and rich flavor. Perfect for a healthy lifestyle and delicious meals!", image: pulese, button:"/products/pulses" }
    ];

    return (
        <section className="product-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">

                        <div class="section-title clearfix">
                            <div class="title-header">
                                <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>WHAT WE OFFER</h5>
                                <h3>OUR PRODUCTS</h3>
                            </div>
                            <div className='underline'></div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {products.map((product, index) => (
                        <div className="col-md-4 col-sm-6 col-12" key={index}>
                            <div className="product-card">
                                <div className="product-icon">
                                    <img src={product.image} width={80} height={80} alt={product.name} />
                                </div>
                                <div className="product-content">
                                    <h5>{product.name}</h5>
                                    <p>{product.description}</p>
                                    <a href={product.button}>Learn More</a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Ourproduct;
